<div class="header cor-master">
    <div class="title">{{mensagem}}</div>
</div>
<form class="flex flex-col  p-8 pb-0  rounded overflow-hidden" [formGroup]="formulario">

    <div class="flex">
        <mat-form-field class="flex-auto">
            <input matInput formControlName="senha" [placeholder]="'Código de acesso'" autocomplete="off" type="number">
            <mat-icon matPrefix [svgIcon]="'lock'"></mat-icon>
        </mat-form-field>
    </div>
</form>
<div class="botoes">
    <button mat-button (click)="confirmar()" class="ml-2 p-2 rounded green-600" mat-button>
        <span>Confirmar</span>
    </button>

</div>
